import React, { useState } from 'react';
import toast from 'react-hot-toast';
import AuthHeader from '@apps/components/AuthHeader';
import { DEFAULT_PATH_BEFORE_SIGN_IN } from '@apps/config';
import { Box, Button, TextField, Typography } from '@mui/material';
import { PageType, SideCover } from '@stack/components';
import { useResetPasswordSendEmailMutation } from '@stack/data-access';
import { redirect } from '@webbyx/next-js';

const ForgotPasswordScreen = () => {
  // ======================= STATE
  const [email, setEmail] = useState<string>('');
  //
  // ======================= API
  const [resetPasswordSendEmailMutation, { loading }] =
    useResetPasswordSendEmailMutation({
      onCompleted: (data) => {
        if (data?.ResetPasswordSendEmail?.status) {
          toast.success(
            data?.ResetPasswordSendEmail?.message ??
              'A password reset link has been sent to your email!'
          );
          redirect({}, DEFAULT_PATH_BEFORE_SIGN_IN, 'replace');
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    });

  // ======================= EVENTS
  const handleSend = () => {
    resetPasswordSendEmailMutation({
      variables: {
        user_email: email,
      },
    });
  };

  const handleBack = () => {
    redirect({}, DEFAULT_PATH_BEFORE_SIGN_IN, 'replace');
  };

  // ======================= VIEWS
  const renderFooter = () => {
    return (
      <Box
        sx={{
          mt: 9,
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={handleSend}
          disabled={loading}
        >
          Send
        </Button>
      </Box>
    );
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: { xs: '100%', lg: '100vh' },
          width: { xs: '100%', lg: '60%' },
          justifyContent: 'center',
          order: { xs: 1, lg: 0 },
          marginTop: { xs: '20px', lg: 0 },
        }}
      >
        <Box
          sx={{
            minWidth: 200,
            maxWidth: 500,
            width: '90%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <AuthHeader
            onBack={handleBack}
            backButtonText={'Back to login'}
            title={'Forgot Password'}
          >
            <Typography color={'secondary'} variant="subtitle1">
              Enter the email address your account is registered to.
            </Typography>
          </AuthHeader>
          <Box sx={{ mt: 12.5 }}>
            <TextField
              label={'Email'}
              placeholder={'123@example.com'}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
            {renderFooter()}
          </Box>
        </Box>
      </Box>
      <SideCover pageType={PageType.MAIN} />
    </Box>
  );
};

export default ForgotPasswordScreen;
